module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>About</h3>\r\n    <p>Justis gives you access to hundreds of thousands of case judgments and legislation from common law jurisdictions around the world. <a href=\"https://www.justis.com/content/\" target=\"_blank\" class=\"training-email\">JustisOne Coverage</a></p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-about-justisone.html
// module id = 378
// module chunks = 1